import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const WebsiteNavbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <nav className={`nx-nav${scrolled ? ' scrolled' : ''}`}>
      <div className="nx-nav-inner">
        <Link to="/" className="nx-brand">
          <img
            src={process.env.PUBLIC_URL + '/logo.png'}
            alt="Nigeria CSI"
          />
          <span className="nx-brand-text">
            <b>Nigeria CSI</b>
            <i>Customer Service Index</i>
          </span>
        </Link>
        <ul className={`nx-links${menuOpen ? ' open' : ''}`}>
          <li><Link to="/" className={isActive('/')}>Home</Link></li>
          <li><Link to="/sectors" className={isActive('/sectors')}>Sectors</Link></li>
          <li><Link to="/about" className={isActive('/about')}>About</Link></li>
          <li><Link to="/contact" className={isActive('/contact')}>Contact</Link></li>
          <li><Link to="/survey/" className="nx-nav-cta">Take the survey</Link></li>
        </ul>
        <button
          className="nx-burger"
          aria-label="Menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span style={menuOpen ? { transform: 'rotate(45deg) translate(5px, 5px)' } : {}}></span>
          <span style={menuOpen ? { opacity: 0 } : {}}></span>
          <span style={menuOpen ? { transform: 'rotate(-45deg) translate(5px, -5px)' } : {}}></span>
        </button>
      </div>
    </nav>
  );
};

export default WebsiteNavbar;
